import dva from 'dva';
import createLoading from 'dva-loading';
import 'moment/dist/locale/zh-cn';
import 'moment/dist/locale/ko';
import 'moment/dist/locale/zh-tw';
import 'moment/dist/locale/pl';
import 'moment/dist/locale/ja';
import 'moment/dist/locale/en-gb';
import lodash from 'lodash';
import { reloadAuthorized } from './utils/Authorized';
import './index.less';
import { i18n, initI18n } from './i18n';
import { getConfig } from './services/server-url-config/env';
import 'antd/dist/antd.css';
import { getAppUrl } from './utils/sso';
import { initializeBurialPoint, EPlatform } from './gs-web-analytics';
// console.log(EPlatform, initializeBurialPoint);
// test -- local

// staging - pre

// release - daily

// prod - prod


const urlConfig = getConfig();

let ENV = '';
switch (urlConfig.env) {
  case 'test':
    ENV = 'local';
    break;
  case 'staging':
    ENV = 'pre';
    break;
  case 'release':
    ENV = 'daily';
    break;
  case 'prod':
    ENV = 'prod';
    break;
  default:
    ENV = '';
}

console.log(`
                  _                 _
  __ _ ___    ___| | ___  _   _  __| |
 / _\` / __|  / __| |/ _ \\| | | |/ _\` |
| (_| \\__ \\ | (__| | (_) | |_| | (_| |
 \\__, |___/  \\___|_|\\___/ \\__,_|\\__,_|
 |___/
`);
console.log(`ui-cloud env: ${urlConfig.env}`);

window.i18n = i18n;
window.i = i18n;
window._ = lodash;

// 确保 EPlatform 存在
console.log('Platform:', urlConfig);

initializeBurialPoint(EPlatform.ROBOT_CLOUD, urlConfig?.apiUrl?.apiGatewayPrefix, urlConfig.lane || urlConfig.region || urlConfig.env);

const createHistory = require('history').createHashHistory;

// 开发log
if (urlConfig.env === 'prod') {
  window.gslogger = () => {};
  window.gswarn = () => {};
  window.console = new Proxy(
    {},
    {
      get() {
        return () => {};
      },
    },
  );
}

// 1. Initialize
initI18n();
let app;
app = dva({
  history: createHistory(),
  onError(err) {
    console.log('error', err);
    window.location.href = getAppUrl();
  },
});
// 2. Plugins
app.use(createLoading());

// 3. Register global model
app.model(require('./models/global').default);
app.model(require('./models/unitSetting').default);
// 4. Router
app.router(require('./router').default);
// 5. Start
app.start('#root');

app._store; // eslint-disable-line
window.app = app;
reloadAuthorized();

window.app = app;
window.gs = {
  LAST_BUILD_TIME: process.env.LAST_BUILD_TIME,
};
